import { Flex, Paper, Text, Title } from "@mantine/core";
import { EditIcon } from "../../shared/svg";
import "./Profile.scss";
import useProfileStore from "../../store/useProfileStore";
import useAuthStore from "../../store/useAuthStore";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { getLanguageName, getProficiencyLabel } from "../../utils/helpers";

export const Languages = () => {
  const { profile } = useProfileStore();
  const { cvProcessing } = useAuthStore();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const languages = profile?.languages || [];

  return (
    <Paper withBorder radius="24px" p={32} h="100%" pos="relative">
      <div
        className="edit-icon"
        onClick={() => navigate("/profile/edit/skills")}
      >
        <EditIcon />
      </div>
      <Title size={36} lh="50px">
        {t("languages")}
      </Title>
      <Flex wrap="wrap" gap={8} mt={30}>
        {languages.length > 0 ? (
          languages.map((language) => (
            <Paper
              key={language.id}
              px={18}
              py={8}
              withBorder
              radius={25}
              style={{
                display: "inline-block",
                borderColor: "#dee2e6",
                minWidth: 120,
                textAlign: "center",
              }}
            >
              <Text fw={500}>{getLanguageName(language.language)}</Text>
              {language.proficiency && (
                <Text size="xs" color="dimmed">
                  {getProficiencyLabel(language.proficiency, t)}
                </Text>
              )}
            </Paper>
          ))
        ) : (
          <Text c="#737373">
            {cvProcessing !== "processing"
              ? t("no_languages")
              : t("no_languages_cv")}
          </Text>
        )}
      </Flex>
    </Paper>
  );
};
